import type { TrendType } from "@/types/trend.type";
import { KitTag } from "@/app/routes/dashboard/components/kit/Tag";
import { TYPE_META } from "./trendMeta";

/**
 * The type of a trend, as an icon and the word in neutral ink: the library's
 * Tag / With glyph (tonal, radius 6). It never takes a colour: a pillar hue
 * means a strategy pillar, and the kind is not one, so the icon and the word
 * carry it on their own.
 */
export default function TrendTypeBadge({ type, className }: { type: TrendType; className?: string }) {
  const { label, icon } = TYPE_META[type];
  return (
    <KitTag icon={icon} tone="ink" className={className}>
      {label}
    </KitTag>
  );
}
